import React, { useState } from 'react';
import { CloseCircle } from 'iconsax-reactjs';
import { useDispatch, useSelector } from 'react-redux';
import { sendBroadcast, clearBroadcastError } from '../../../../redux/slices/admin_organisation/broadcastSlice';
import { toast } from 'react-toastify';
import './BroadcastModal.css';

const BroadcastModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.broadcasts);
  
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    type: 'broadcast',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const resultAction = await dispatch(sendBroadcast(formData));
    
    if (sendBroadcast.fulfilled.match(resultAction)) {
      toast.success('Broadcast sent successfully!');
      setFormData({ title: '', content: '', type: 'broadcast' });
      onClose();
    } else if (sendBroadcast.rejected.match(resultAction)) {
      toast.error(resultAction.payload || 'Failed to send broadcast');
    }
  };

  const handleClose = () => {
    dispatch(clearBroadcastError());
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="broadcast-modal-overlay" onClick={handleClose}>
      <div className="broadcast-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="broadcast-modal-header">
          <h2>Send Broadcast Message</h2>
          <button className="close-btn" onClick={handleClose}>
            <CloseCircle size="24" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="broadcast-modal-form">
          <div className="form-group">
            <label htmlFor="title">Broadcast Title <span className="required">*</span></label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter broadcast title"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="type">Message Type</label>
            <select
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="broadcast">General Broadcast</option>
              <option value="news">News Update</option>
              <option value="class">Class Update</option>
              <option value="assignment">Assignment Alert</option>
              <option value="payment">Payment Notice</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="content">Message Content <span className="required">*</span></label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleChange}
              rows="6"
              placeholder="Write your message here... You can use HTML for basic formatting."
              required
            ></textarea>
            <p className="helper-text">This message will be sent to ALL users in your organization.</p>
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-submit"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Broadcast'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BroadcastModal;
